import { OwnContractModelMapper } from './OwnContractModelMapper.js';

class OwnContractModelRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  getModels() {
    return this.apiClient.get('pro/contract-models').then(response => response.data.map(OwnContractModelMapper.createFromResponse));
  }
}

export { OwnContractModelRepository };
//# sourceMappingURL=OwnContractModelRepository.js.map
